import axios from 'axios';

export interface ICepAddress {
  street: string;
  district: string;
  city: string;
  state: string;
}

interface ICepResponse {
  address?: string;
  district?: string;
  city?: string;
  state?: string;
}

export async function fetchAddressByCep(
  cep: string
): Promise<ICepAddress | null> {
  const digits = (cep ?? '').replace(/\D/g, '');
  if (digits.length !== 8) return null;

  try {
    const { data } = await axios.get<ICepResponse>(
      `https://cep.awesomeapi.com.br/json/${digits}`,
      { timeout: 8000 }
    );

    if (!data?.city || !data?.state) return null;

    return {
      street: data.address ?? '',
      district: data.district ?? '',
      city: data.city,
      state: data.state,
    };
  } catch {
    return null;
  }
}
